module.exports = __webpack_public_path__ + "img/core_values.b5bb0b48.png";